import { CitiesResponse } from '@/core/domain/address/models/cities-response.model';
import { CitiesRepository } from '@/core/domain/cities/repositories/cities.repository';
import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CitiesImplRepository extends CitiesRepository {
    constructor(private readonly httpClient: HttpClient) {
        super();
    }

    override getCities(): Observable<CitiesResponse> {
        return this.httpClient
            .get<CitiesResponse>(
                [
                    environment.alamoApi.BASE_HOST,
                    environment.alamoApi.ENDPOINTS.citiesDestinations,
                ].join('/'),
            )
            .pipe(
                switchMap((citiesResponse: CitiesResponse) => {
                    const cities: CitiesResponse = {
                        type: citiesResponse.type,
                        action: citiesResponse.action,
                        notifications: citiesResponse.notifications,
                        data: citiesResponse.data,
                    };

                    return of(cities);
                }),
            );
    }
}
